import { BackIcon } from '../../reusable-components';
import { useTranslation } from "react-i18next";
import { Button, Grid, SxProps, Theme, Typography } from '@mui/material';
import { getProTypes, getSuggestion } from '../../common/proPickUtil';
import { Fixture } from '../../models/fixture';
import { themeC } from '../../theme/themehelper';
import { PoolXMoney } from '../../models/money';
import { trackCouponTool } from '../../analytics/analytics';


export function ProPickSelector({ fixtures, setShowProPick, operatorStakePerRow, operatorFeePerRow, proPickName,
    setProPickRows
}: {
    fixtures: Fixture[], setShowProPick: (show: boolean) => void, operatorStakePerRow: PoolXMoney,
    operatorFeePerRow: PoolXMoney, proPickName: string, setProPickRows: (rows: string[][]) => void
}) {

    const { t } = useTranslation();
    const roundFixtures = fixtures;

    const titleStyle: SxProps<Theme> = {
        color: "var(--text-black)",
        fontWeight: "bold"
    };

    const gridStyle: SxProps<Theme> = {
        padding: "20px",
        margin: "10px 0 16px 0",
        gridTemplateColumns: "50% 50%",
        gap: "4px"
    };

    const buttonStyle: SxProps<Theme> = {
        background: 'var(--button-color)',
        borderRadius: 'var(--button-border-radius)',
        color: 'var(--button-text-color)',
        padding: "12px",
        minWidth: '150px',
        fontFamily: 'var(--font-button)',
        fontSize: '14px',
        fontWeight: 'var(--font-weight-button)',
        textTransform: 'var(--text-transform-button)',
        '&:hover': {
            backgroundColor: 'var(--button-hover-color)'
        }
    }


    if (window.theme === themeC.Hard) {
        titleStyle.color = "var(--text-white)";
    }

    return (
        <Grid container direction="column" justifyContent="center">
            <Grid container direction="column" alignItems="center" sx={{ marginBottom: "40px" }}>

                <Grid container alignItems="center" sx={{
                    width: "90%", margin: "20px", cursor: "pointer",
                    '&:hover': { opacity: 0.8 },
                }} onClick={() => setShowProPick(false)}>
                    <Grid sx={{ paddingTop: "5px", margin: "0px 10px 0px 0px" }}>{BackIcon("var(--text-black-dark-background)")}</Grid>
                    <Typography sx={{ fontWeight: "bold" }}>{t('go_back')}</Typography>
                </Grid>
                <Typography sx={titleStyle}>{proPickName}</Typography>

                <Grid container sx={{ ...gridStyle, maxWidth: "400px" }} justifyContent="center">
                    <Typography sx={{ ...titleStyle, minWidth: "150px", textAlign: "center" }}>{t('often')}</Typography>
                    <Typography sx={{ ...titleStyle, minWidth: "150px", textAlign: "center" }}>{t('a_lot')}</Typography>

                    {getProTypes(roundFixtures.length, operatorStakePerRow, operatorFeePerRow, t).map((protyp, index) =>
                        <Button sx={buttonStyle} key={'propick' + index} onClick={() => {
                            trackCouponTool("pro_pick", { num_full: protyp.numFull, num_half: protyp.numHalf });
                            getSuggestion(protyp, roundFixtures, setProPickRows);
                            setShowProPick(false);
                        }
                        } >
                            {protyp.price}
                        </Button>
                    )}
                </Grid>

            </Grid>

        </Grid>

    );
}